import { WebApi } from '@/services/WebApi'

const state = () => ({
  loadingClientAddress: false,
  loadedClientAddress: false,
  clientAddressCache: null
})

const mutations = {
  setClientAddress (state, clientAddress) {
    state.clientAddressCache = clientAddress
    state.loadedClientAddress = true
  },
  setLoading (state, value) {
    state.loadingClientAddress = value
  }
}

const actions = {
  fetchClientAddress ({ commit }, inviteId) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.get('ClientOnboardingInvite/' + inviteId + '/Client/Address')
        .then(response => {
          commit('setClientAddress', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoading', false))
    })
  },
  addClientAddress ({ commit }, { inviteId, payload }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.post('ClientOnboardingInvite/' + inviteId + '/Client/Address', payload)
        .then(response => {
          commit('setClientAddress', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoading', false))
    })
  },
  updateClientAddress ({ commit }, { inviteId, payload }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.put('ClientOnboardingInvite/' + inviteId + '/Client/Address', payload)
        .then(response => {
          commit('setClientAddress', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoading', false))
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
